import { c as _c } from "react/compiler-runtime";
import type { CommunityMemberMinimal } from "@/entities/IProfile";
import { useQuery } from "@tanstack/react-query";
import { commonApiFetch } from "@/services/api/common-api";
import { AnimatePresence, motion } from "framer-motion";
import GroupCreateIdentitiesSearchItemsContent from "./GroupCreateIdentitiesSearchItemsContent";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
export type GroupCreateIdentitiesSearchResultsLayout = "popover" | "inline";
function GroupCreateIdentitiesSearchItems(t0) {
  const $ = _c(17);
  const {
    open,
    searchCriteria,
    selectedWallets,
    resultsLayout: t1,
    onSelect
  } = t0;
  const resultsLayout = t1 === undefined ? "popover" : t1;
  let t2;
  let t3;
  if ($[0] !== searchCriteria) {
    t2 = [QueryKey.PROFILE_SEARCH, {
      param: searchCriteria,
      only_profile_owners: "true"
    }];
    t3 = async () => await commonApiFetch({
      endpoint: "community-members",
      params: {
        param: searchCriteria ?? "",
        only_profile_owners: "true"
      }
    });
    $[0] = searchCriteria;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  const t4 = !!searchCriteria && searchCriteria.length >= 3;
  let t5;
  if ($[3] !== t2 || $[4] !== t3 || $[5] !== t4) {
    t5 = {
      queryKey: t2,
      queryFn: t3,
      enabled: t4
    };
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const {
    data,
    isFetching
  } = useQuery(t5);
  const wrapperClasses = resultsLayout === "inline" ? "tw-mt-1 tw-w-full tw-rounded-lg tw-bg-iron-800 tw-shadow-xl tw-ring-1 tw-ring-black tw-ring-opacity-5" : "tw-absolute tw-z-[60] tw-mt-1 tw-w-full tw-rounded-lg tw-bg-iron-800 tw-shadow-xl tw-ring-1 tw-ring-black tw-ring-opacity-5";
  const panelClasses = resultsLayout === "inline" ? "tw-w-full tw-overflow-hidden tw-rounded-md tw-bg-iron-800 tw-shadow-2xl tw-ring-1 tw-ring-white/10" : "tw-absolute tw-z-[60] tw-mt-1 tw-w-full tw-overflow-hidden tw-rounded-md tw-bg-iron-800 tw-shadow-2xl tw-ring-1 tw-ring-white/10";
  let t6;
  if ($[7] !== data || $[8] !== isFetching || $[9] !== onSelect || $[10] !== open || $[11] !== panelClasses || $[12] !== selectedWallets || $[13] !== wrapperClasses) {
    t6 = open && <motion.div className={wrapperClasses} initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -20
    }} transition={{
      duration: 0.2
    }}><div className={panelClasses}><div className="tw-py-1 tw-flow-root tw-overflow-x-hidden tw-overflow-y-auto tw-max-h-64 tw-scrollbar-thin tw-scrollbar-thumb-iron-500 tw-scrollbar-track-iron-800 hover:tw-scrollbar-thumb-iron-300"><ul className="tw-flex tw-flex-col tw-gap-y-1 tw-px-2 tw-mx-0 tw-mb-0 tw-list-none"><GroupCreateIdentitiesSearchItemsContent selectedWallets={selectedWallets} loading={isFetching} items={data ?? []} onSelect={onSelect} /></ul></div></div></motion.div>;
    $[7] = data;
    $[8] = isFetching;
    $[9] = onSelect;
    $[10] = open;
    $[11] = panelClasses;
    $[12] = selectedWallets;
    $[13] = wrapperClasses;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t6) {
    t7 = <AnimatePresence mode="wait" initial={false}>{t6}</AnimatePresence>;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}
export default GroupCreateIdentitiesSearchItems;